import wxMemberRouters from './wx-member/routers'

export default[
  ...wxMemberRouters
]



// WEBPACK FOOTER //
// ./src/pages/page-routers.js